const state = {
  stepTabIndex: 0
}

const getters = {
  stepTabIndex: state => state.stepTabIndex,
}

const mutations = {
  SET_STEP_TAG(state, payload) {
    state.stepTabIndex = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
